import React, { useState, useEffect } from 'react';
import { makeStyles, TextField, useRadioGroup } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import SubmitButton from 'components/SubmitButton';
import SimpleForm from 'components/SimpleForm';
import { StripeElementWrapper } from '../SignUp/StripeElementWrapper'
import { CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import { ZipCodeMask } from 'components/maskedInputs';
import { Elements } from 'react-stripe-elements';
import StripeHookProvider from 'components/Stripe/StripeHookProvider';
import withAuthorization from 'components/Session/withAuthorization';
import { useFirebase } from 'components/Firebase/context';
import { useStripe } from 'components/Stripe/StripeHookProvider';

import TextError from 'components/TextError';
import { messages } from '../../messages';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto',
    maxWidth: 500,
  },
  image: {
    width: 128,
    height: 128,
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
}));

const AddSubscription = (props, authUser) => {
  console.log(props.uid);
  const classes = useStyles();
  const firebase = useFirebase();
  const stripe = useStripe();
  const [membership, setMembership] = useState({
    // membershipType: 'trial',
    name: '',
    address_zip: ''
  });
  const [error, setError] = useState(null);
  const [paymentMessage, setpaymentMessage] = useState(null);

  const onMembershipChanged = (name, value) => {
    setMembership({ ...membership, [name]: value });
  };
  async function handlePayment() {
    //   try{
    //     // console.log('submit', membership);
    //     const { token, error } = await stripe.createToken({ name: membership.name });
    //     if (error) return setError(error.message);
    //       const refToken = firebase.getToken(props.uid);
    //       refToken.get().then((snap) => {
    //         snap.forEach((doc) => {
    //         const updateRef = firebase.firestore.collection('stripe_customers').doc(doc.id).collection('tokens');
    //         updateRef.set({
    //           token,
    //         })
    //   });
    // })
    //       // await firebase.firestore
    //       //   .collection('stripe_customers')
    //       //   .doc(props.uid && props.uid)
    //       //   .collection('tokens')
    //       //   .set({ token: token.id })
    //       //   .update({ token: token.id });
    //       setpaymentMessage(messages.successMessage);
    //   } catch (e) {
    //     if (e.message) return setError(e.message);
    //     setError('An unexpected error occured!');
    //   }
  }
  useEffect(() => {
    if (props.uid) {
      const refToken = firebase.getToken(props.uid);
      refToken.get().then((snap) => {
        snap.forEach((doc) => {
          const token = doc.data();
          const test = responseToken(token.token);
        });
      });
    }
  })
  // const getToken = () => {

  // }
  //tok_1G3dLBAMpdqMfB0jQsZz6XCr
  async function responseToken(token) {
    await fetch('https://api.stripe.com/v1/tokens/' + token, {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer sk_test_MYEbvmTwBrdJpr9f3J46KbpV00gO6wNMYW',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // setMembership({name: data.card.name})
        console.log('Success:', data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <SimpleForm
              title="Payment Setting"
              //errorText={errorText}
              onSubmit={handlePayment}
            >
              {paymentMessage && <span>{paymentMessage}</span>}
              {error && <TextError>{error}</TextError>}
              <TextField
                label="Cardholder Name"
                required
                autoFocus
                fullWidth
                onChange={e => onMembershipChanged('name', e.target.value)}
                autoComplete="cc-name"
                margin="normal"
              />
              <StripeElementWrapper label="Card Number" component={CardNumberElement} />
              <StripeElementWrapper label="Expiry (MM / YY)" component={CardExpiryElement} />
              <StripeElementWrapper label="CVC" component={CardCVCElement} />
              <SubmitButton>Submit</SubmitButton>
            </SimpleForm>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default withAuthorization()(AddSubscription);

